import { useState, useEffect } from "react";
import { mascaraTelefone } from "utils/telefone";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import http from "services/http";
import InputUsuario from "components/Usuarios/InputUsuario";
import { alerta } from "../../../../components/Alert";
import { toast } from "react-toastify";
import { moedaInput, parseMoeda } from "../../../../utils/moedaInput";
import { tipoOperador } from "../../../../utils/tipoOperador";

const MySwal = withReactContent(Swal);

// Vem da rota (/usuarios/criar/:nivel) ou das props: a tela "Novo Cliente" renderiza
// este mesmo formulário com nivel="operador" e tipo="cliente".
export default function CriarUsuario({ history, match, nivel: nivelProp, tipo: tipoProp }) {
    const [nivelLogado] = useState(localStorage.getItem("nivel"));
    const [nivelSelecionado] = useState(nivelProp ?? match.params.nivel);
    // Só para operador: cambista (padrão) ou cliente, fixo pela tela que abriu.
    const operador = tipoOperador(tipoProp);
    const [login, setLogin] = useState("");
    const [senha, setSenha] = useState("");
    const [gerente, setGerente] = useState(0);
    const [listaGerente, setListaGerente] = useState([]);
    const [tipoUsuario, setTipoUsuario] = useState("gerente");
    const [comissaoGerente, setComissaoGerente] = useState(0);
    const [comissaoLucro, setComissaoLucro] = useState(0);
    const [porcentagemSocio, setPorcentagemSocio] = useState(0);
    const [saldo, setSaldo] = useState('1.000,00');
    const [comissaoMilhar, setComissaoMilhar] = useState(30);
    const [comissaoCentena, setComissaoCentena] = useState(30);
    const [comissaoDezena, setComissaoDezena] = useState(30);
    const [comissaoGrupo, setComissaoGrupo] = useState(30);
    const [cotaEscolhida, setCotaEscolhida] = useState(1);
    const [endereco, setEndereco] = useState("");
    const [milharBrindeUsuario, setMilharBrindeUsuario] = useState(true);
    const [telefone, setTelefone] = useState("");
    const [descricao, setDescricao] = useState("");
    const [modalidades, setModalidades] = useState([]);
    const [permissaoCriarOperador, setPermissaoCriarOperador] = useState(false);
    const [permissaoExibirLogo, setPermissaoExibirLogo] = useState(true);
    const [permissaoAdicionarSaldo, setPermissaoAdicionarSaldo] =
        useState(false);
    const [permissoesMarcadas, setPermissoesMarcadas] = useState([]);
    const [listaPermissoes, setListaPermissoes] = useState([]);
    const [show, setShow] = useState(null);
    const [carregaPost, setCarregaPost] = useState(false);
    const [cotacaoSelecionada, setCotacaoSelecionada] = useState(null);

    // Função para extrair valores da cotação
    const extrairValoresCotacao = (nomeCotacao) => {
        if (!nomeCotacao) return { M: 0, C: 0, D: 0, G: 0 };

        const regex = /M:\s*(\d+)\s*\/\s*C:\s*(\d+)\s*\/\s*D:\s*(\d+)\s*\/\s*G:\s*(\d+)/;
        const match = nomeCotacao.match(regex);

        if (match) {
            return {
                M: parseInt(match[1]),
                C: parseInt(match[2]),
                D: parseInt(match[3]),
                G: parseInt(match[4])
            };
        }
        return { M: 0, C: 0, D: 0, G: 0 };
    };

    // Função para calcular indicador de Milhar
    const calcularIndicadorMilhar = (cotacao, comissao) => {
        const M = cotacao + (comissao * 100);
        if (M > 9999) return { cor: '#dc3545', status: 'ALTA', simbolo: '●' }; // Vermelho
        if (M >= 8999 && M <= 9999) return { cor: '#ffc107', status: 'MÉDIA', simbolo: '●' }; // Amarelo
        return { cor: '#28a745', status: 'BAIXA', simbolo: '●' }; // Verde
    };

    // Função para calcular indicador de Centena
    const calcularIndicadorCentena = (cotacao, comissao) => {
        const C = cotacao + (comissao * 10);
        if (C > 999) return { cor: '#dc3545', status: 'ALTA', simbolo: '●' }; // Vermelho
        if (C >= 899 && C <= 999) return { cor: '#ffc107', status: 'MÉDIA', simbolo: '●' }; // Amarelo
        return { cor: '#28a745', status: 'BAIXA', simbolo: '●' }; // Verde
    };

    // Função para calcular indicador de Dezena
    const calcularIndicadorDezena = (cotacao, comissao) => {
        const D = cotacao + comissao;
        if (D > 99) return { cor: '#dc3545', status: 'ALTA', simbolo: '●' }; // Vermelho
        if (D >= 89 && D <= 99) return { cor: '#ffc107', status: 'MÉDIA', simbolo: '●' }; // Amarelo
        return { cor: '#28a745', status: 'BAIXA', simbolo: '●' }; // Verde
    };

    // Função para calcular indicador de Grupo
    const calcularIndicadorGrupo = (cotacao, comissao) => {
        const G = 25.00 - cotacao - (comissao * 0.25);
        if (G <= 0) return { cor: '#dc3545', status: 'ALTA', simbolo: '●' }; // Vermelho
        if (G > 0 && G < 2.50) return { cor: '#ffc107', status: 'MÉDIA', simbolo: '●' }; // Amarelo
        return { cor: '#28a745', status: 'BAIXA', simbolo: '●' }; // Verde
    };

    // Função para obter indicador geral
    const obterIndicadorGeral = () => {
        if (!cotacaoSelecionada) return { cor: '#6c757d', status: 'SEM COTAÇÃO' };

        const valores = extrairValoresCotacao(cotacaoSelecionada.nome);
        const indMilhar = calcularIndicadorMilhar(valores.M, parseFloat(comissaoMilhar) || 0);
        const indCentena = calcularIndicadorCentena(valores.C, parseFloat(comissaoCentena) || 0);
        const indDezena = calcularIndicadorDezena(valores.D, parseFloat(comissaoDezena) || 0);
        const indGrupo = calcularIndicadorGrupo(valores.G, parseFloat(comissaoGrupo) || 0);

        // Se algum estiver vermelho, é alta
        if ([indMilhar, indCentena, indDezena, indGrupo].some(ind => ind.status === 'ALTA')) {
            return { cor: '#dc3545', status: 'COMISSÃO ALTA' };
        }

        // Se algum estiver amarelo, é média
        if ([indMilhar, indCentena, indDezena, indGrupo].some(ind => ind.status === 'MÉDIA')) {
            return { cor: '#ffc107', status: 'COMISSÃO MÉDIA' };
        }

        return { cor: '#28a745', status: 'COMISSÃO BAIXA' };
    };

    useEffect(() => {
        const requestGerentes = async () => {
            try {
                const resModalidades = await http.get("bancas/titulo-cotacoes");

                setModalidades(resModalidades.data.data);

                // Define a primeira cotação como selecionada
                if (resModalidades.data.data.length > 0) {
                    setCotacaoSelecionada(resModalidades.data.data[0]);
                }

                if (nivelLogado === "gerente") {
                    const usuario = await JSON.parse(
                        localStorage.getItem("usuario")
                    );
                    setGerente(usuario.id);
                    return;
                }

                const response = await http.get("/usuarios", {
                    params: {
                        nivel: "gerente",
                    },
                });

                const { data: usuarios } = response.data;

                usuarios.unshift({ login: "Escolha um gerente", id: 0 });

                setListaGerente(usuarios);
            } catch (e) {
                console.log(e);
            }
        };

        requestPermissions();

        if (nivelSelecionado === "operador") {
            requestGerentes();
        }
    }, [nivelSelecionado]);

    // Atualizar cotação selecionada quando mudar
    useEffect(() => {
        const cotacao = modalidades.find(m => m.id === parseInt(cotaEscolhida));
        if (cotacao) {
            setCotacaoSelecionada(cotacao);
        }
    }, [cotaEscolhida, modalidades]);

    const isChecked = (event, perm) => {
        if (event.target.checked) {
            setPermissoesMarcadas([
                ...permissoesMarcadas,
                perm
            ])
        } else {
            const newPermissions = permissoesMarcadas.filter((nome) => nome !== perm);
            setPermissoesMarcadas(newPermissions);
        }
    }


    const ListPermission = ({ grupo, permissoes, index }) => {
        return (
            <div className="card">
                <div id="headingOne">
                    <h5 className="mb-0">
                        <button className="btn btn-link" onClick={() => setShow(index != show ? index : null)}>
                            {grupo}
                        </button>
                    </h5>
                </div>
                <div id="collapseOne" className={`collapse ${show == index ? 'show' : ''}`}>
                    <div className="card-body">
                        {permissoes.map((perm) =>
                            <div className="funkyradio-info">
                                <input id={perm} className="mr-1"
                                    type="checkbox"
                                    checked={permissoesMarcadas.includes(perm)}
                                    onChange={(e) => {
                                        isChecked(e, perm);
                                    }}
                                />
                                <label for={perm}>{perm}</label>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    const requestPermissions = async () => {
        try {
            const response = await http.get("/permissoes/agrupado");

            const { data: permissoes } = response.data;

            console.log(Object.entries(permissoes));

            setListaPermissoes(permissoes);
        } catch (e) {
            console.log(e);
        }
    };

    const enviarUsuario = async (e) => {
        if (nivelSelecionado === "operador") {
            if (!gerente || gerente < 1) {
                MySwal.fire({
                    type: "error",
                    title: "Escolha um gerente para continuar",
                });

                return;
            }
        }

        if ((senha.length < 6 || senha.length > 18) && senha.length !== 0) {
            toast.error('A senha deve ter entre 6 e 18 caracteres');
            return;
        }

        try {
            const { data } = await http.post("/usuarios", {
                login: login,
                password: senha,
                nivel: nivelSelecionado,
                gerente_id: gerente || null,
                comissao_milhar: comissaoMilhar || 0,
                comissao_centena: comissaoCentena || 0,
                comissao_dezena: comissaoDezena || 0,
                comissao_grupo: comissaoGrupo || 0,
                saldo: parseMoeda(saldo),
                tipo_usuario: nivelSelecionado === "operador" ? operador.tipo : tipoUsuario,
                comissao_gerente: comissaoGerente || 0,
                comissao_lucro: comissaoLucro || 0,
                porcentagem_socio: porcentagemSocio || 0,
                cotas: cotaEscolhida,
                milhar_brinde_usuario: milharBrindeUsuario ? 1 : 0,
                exibir_logo: permissaoExibirLogo,
                endereco: endereco,
                telefone,
                observacao: descricao,
                lista_permissoes: permissoesMarcadas,
                permissao_criar_operador: permissaoCriarOperador,
                permissao_adicionar_saldo: permissaoAdicionarSaldo,
            });

            alerta(data);
            if (nivelSelecionado === 'subadmin' && data.data?.id) {
                history.push(`/usuarios/${data.data.id}/login`);
            } else {
                history.goBack();
            }
        } catch (e) {
            setCarregaPost(false);
            alerta(e.response.data);
        }
    };

    const handleComissaoChange = (valor, setter, max = 99) => {
        // Limita a 2 dígitos
        const valorLimitado = valor.slice(0, 2);
        const numero = parseInt(valorLimitado) || 0;
        if (numero <= max) {
            setter(valorLimitado);
        }
    };

    return (
        <div className="bordered">
            <div>
                <div className="titulo-principal">
                    {nivelSelecionado === "operador" && operador.tituloCriar}
                    {nivelSelecionado === "gerente" && "Criar gerente"}
                    {nivelSelecionado === "subadmin" && "Criar subadmin"}
                </div>
                <div className="btn-group caixa-inputs p-b">
                    <div className="input-criacao-usuario margin-vertical-30">
                        <label className="titulo-input-criacao">
                            Criado em:
                        </label>
                        <input
                            disabled
                            className="form-control input-dados-criar"
                            value=""
                        />
                    </div>

                    {nivelSelecionado === "operador" &&
                        nivelLogado === "admin" ? (
                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">
                                Gerente:
                            </label>
                            <select
                                required
                                className="form-control input-dados-criar"
                                id="inputGerente"
                                onChange={(e) => setGerente(e.target.value)}
                            >
                                {listaGerente.map((item, index) => {
                                    return (
                                        <option key={index} value={item.id}>
                                            {item.login}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    ) : null}

                    <InputUsuario
                        valor={login}
                        func={(e) => setLogin(e)}
                        name={"Login"}
                        tipo={"text"}
                    />
                    <InputUsuario
                        valor={senha}
                        func={(e) => setSenha(e)}
                        name={"Senha"}
                        tipo={"password"}
                    />

                    {nivelSelecionado === "operador" ? (
                        <>
                            <InputUsuario
                                name={"Saldo (R$)"}
                                valor={saldo}
                                func={(e) => setSaldo(moedaInput(e))}
                                inputMode="decimal"
                            />

                            <div className="input-criacao-usuario margin-vertical-30">
                                <label className="titulo-input-criacao">Cotações (R$):</label>
                                <select
                                    required
                                    className="form-control input-dados-criar"
                                    id="inputGerente"
                                    onChange={(e) => setCotaEscolhida(e.target.value)}
                                >
                                    {modalidades.map((m) => (
                                        <option key={m.id} value={m.id}>
                                            {m.nome.replace(/duque\s*de\s*grupo\s*combinado/gi, "Grupo Combinado")}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="input-criacao-usuario margin-vertical-30">
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label className="titulo-input-criacao" style={{ flex: 1 }}>Comissão (%):</label>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', flexDirection: 'column' }}>
                                    </div>
                                    {cotacaoSelecionada && (() => {
                                        const indicador = obterIndicadorGeral();
                                        return (
                                            <span style={{
                                                backgroundColor: indicador.cor,
                                                color: '#fff',
                                                padding: '4px 12px',
                                                borderRadius: '12px',
                                                fontSize: '11px',
                                                fontWeight: 'bold'
                                            }}>
                                                {indicador.status}
                                            </span>
                                        );
                                    })()}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', flexDirection: 'column' }}>
                                    <div style={{ flex: '0 0 auto', minWidth: '450px' }}>
                                        <div style={{
                                            display: 'flex',
                                            gap: '1px',
                                            marginTop: '10px',
                                            alignItems: 'flex-start',
                                            marginLeft: '35px',
                                        }}>
                                            {cotacaoSelecionada && (() => {
                                                const valores = extrairValoresCotacao(cotacaoSelecionada.nome);
                                                const indMilhar = calcularIndicadorMilhar(valores.M, parseFloat(comissaoMilhar) || 0);
                                                const indCentena = calcularIndicadorCentena(valores.C, parseFloat(comissaoCentena) || 0);
                                                const indDezena = calcularIndicadorDezena(valores.D, parseFloat(comissaoDezena) || 0);
                                                const indGrupo = calcularIndicadorGrupo(valores.G, parseFloat(comissaoGrupo) || 0);

                                                return (
                                                    <>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginBottom: '3px' }}>
                                                                <span style={{
                                                                    fontSize: '11px',
                                                                    fontWeight: '500',
                                                                    color: '#666'
                                                                }}>Milhar</span>
                                                                <span style={{
                                                                    fontSize: '15px',
                                                                    color: indMilhar.cor
                                                                }}>{indMilhar.simbolo}</span>
                                                            </div>
                                                            <input
                                                                type="number"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                className="form-control"
                                                                style={{ width: '40px', textAlign: 'center', minWidth: '66.8px' }}
                                                                value={comissaoMilhar}
                                                                onChange={(e) => handleComissaoChange(e.target.value, setComissaoMilhar)}
                                                                placeholder="30"
                                                                maxLength="2"
                                                            />                                                    </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginBottom: '3px' }}>
                                                                <span style={{
                                                                    fontSize: '11px',
                                                                    fontWeight: '500',
                                                                    color: '#666'
                                                                }}>Centena</span>
                                                                <span style={{
                                                                    fontSize: '15px',
                                                                    color: indCentena.cor
                                                                }}>{indCentena.simbolo}</span>
                                                            </div>
                                                            <input
                                                                type="number"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                className="form-control"
                                                                style={{ width: '40px', textAlign: 'center', minWidth: '66.8px' }}
                                                                value={comissaoCentena}
                                                                onChange={(e) => handleComissaoChange(e.target.value, setComissaoCentena)}
                                                                placeholder="30"
                                                                maxLength="2"
                                                            />                                                    </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginBottom: '3px' }}>
                                                                <span style={{
                                                                    fontSize: '11px',
                                                                    fontWeight: '500',
                                                                    color: '#666'
                                                                }}>Dezena</span>
                                                                <span style={{
                                                                    fontSize: '15px',
                                                                    color: indDezena.cor
                                                                }}>{indDezena.simbolo}</span>
                                                            </div>
                                                            <input
                                                                type="number"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                className="form-control"
                                                                style={{ width: '40px', textAlign: 'center', minWidth: '66.8px' }}
                                                                value={comissaoDezena}
                                                                onChange={(e) => handleComissaoChange(e.target.value, setComissaoDezena)}
                                                                placeholder="30"
                                                                maxLength="2"
                                                            />                                                    </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginBottom: '3px' }}>
                                                                <span style={{
                                                                    fontSize: '11px',
                                                                    fontWeight: '500',
                                                                    color: '#666'
                                                                }}>Grupo</span>
                                                                <span style={{
                                                                    fontSize: '15px',
                                                                    color: indGrupo.cor
                                                                }}>{indGrupo.simbolo}</span>
                                                            </div>
                                                            <input
                                                                type="number"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                className="form-control"
                                                                style={{ width: '40px', textAlign: 'center', minWidth: '66.8px' }}
                                                                value={comissaoGrupo}
                                                                onChange={(e) => handleComissaoChange(e.target.value, setComissaoGrupo)}
                                                                placeholder="30"
                                                                maxLength="2"
                                                            />                                                    </div>
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </div>

                                    <div style={{
                                        flex: '1',
                                        marginLeft: '20px',
                                        position: 'absolute',
                                        left: '49%',
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            marginBottom: '10px',
                                            fontStyle: 'italic',
                                            fontWeight: 'bold'
                                        }}>
                                            Tabela de referência de comissão
                                        </div>
                                        <table style={{
                                            width: '100%',
                                            fontSize: '11px',
                                            borderCollapse: 'collapse',
                                            border: '1px solid #dee2e6',
                                        }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#f8f9fa' }}>
                                                    <th style={{
                                                        color: '#4169E1',
                                                        textAlign: 'center',
                                                        padding: '6px 4px',
                                                        fontWeight: '600',
                                                        borderRight: '1px solid #dee2e6',
                                                        borderBottom: '1px solid #dee2e6'
                                                    }}>Milhar</th>
                                                    <th style={{
                                                        color: '#4169E1',
                                                        textAlign: 'center',
                                                        padding: '6px 4px',
                                                        fontWeight: '600',
                                                        borderRight: '1px solid #dee2e6',
                                                        borderBottom: '1px solid #dee2e6'
                                                    }}>Centena</th>
                                                    <th style={{
                                                        color: '#4169E1',
                                                        textAlign: 'center',
                                                        padding: '6px 4px',
                                                        fontWeight: '600',
                                                        borderRight: '1px solid #dee2e6',
                                                        borderBottom: '1px solid #dee2e6'
                                                    }}>Dezena</th>
                                                    <th style={{
                                                        color: '#4169E1',
                                                        textAlign: 'center',
                                                        padding: '6px 4px',
                                                        fontWeight: '600',
                                                        borderBottom: '1px solid #dee2e6'
                                                    }}>Grupo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>5.000→30%</td>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>500→30%</td>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>60→30%</td>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center' }}>15→30%</td>
                                                </tr>
                                                <tr style={{ backgroundColor: '#f8f9fa' }}>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>6.000→30%</td>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>600→30%</td>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>70→20%</td>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center' }}>18→15%</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>7.000→20%</td>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>700→20%</td>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>80→10%</td>
                                                    <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center' }}>20→10%</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div style={{
                                            marginTop: '15px',
                                            padding: '10px',
                                            backgroundColor: '#fff3cd',
                                            border: '1px solid #ffc107',
                                            borderRadius: '4px',
                                            fontSize: '11px'
                                        }}>
                                            <strong style={{ color: '#856404' }}>⚠️ Legendas dos indicadores:</strong>
                                            <div style={{ marginTop: '1px', lineHeight: '1.6' }}>
                                                <div><span style={{ color: '#28a745' }}>● Verde</span> = Comissão baixa (ideal)</div>
                                                <div><span style={{ color: '#ffc107' }}>● Amarelo</span> = Comissão média (atenção)</div>
                                                <div><span style={{ color: '#dc3545' }}>● Vermelho</span> = Comissão alta (risco)</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}

                    {nivelSelecionado === "gerente" ? (
                        <>
                            <div className="input-criacao-usuario margin-vertical-30">
                                <label
                                    className="titulo-input-criacao"
                                    style={{ marginBottom: 10 }}
                                >
                                    Tipo:
                                </label>
                                <select
                                    required
                                    className="form-control input-dados-criar"
                                    id="inputTipoUsuario"
                                    value={tipoUsuario}
                                    onChange={(e) =>
                                        setTipoUsuario(e.target.value)
                                    }
                                >
                                    <option value={"gerente"}>Gerente</option>
                                    <option value={"socio"}>Sócio</option>
                                </select>
                            </div>

                            {tipoUsuario === "gerente" ? (
                                <>
                                    <InputUsuario
                                        name={"Comissão Bruto (%)"}
                                        valor={comissaoGerente}
                                        func={(e) => setComissaoGerente(e.replace(/\D/g, '').slice(0, 2))}
                                        inputMode="numeric"
                                        maxLength="2"
                                    />
                                    <InputUsuario
                                        name={"Comissão Lucro (%)"}
                                        valor={comissaoLucro}
                                        func={(e) => setComissaoLucro(e.replace(/\D/g, '').slice(0, 2))}
                                        inputMode="numeric"
                                        maxLength="2"
                                    />
                                </>
                            ) : tipoUsuario === "socio" ? (
                                <InputUsuario
                                    name={"% Sócio"}
                                    valor={porcentagemSocio}
                                    func={(e) => setPorcentagemSocio(e)}
                                    tipo={"number"}
                                />
                            ) : (
                                <></>
                            )}
                        </>
                    ) : null}

                    <InputUsuario
                        name={"Endereço"}
                        valor={endereco}
                        func={(e) => setEndereco(e)}
                        tipo={"text"}
                    />
                    <InputUsuario
                        name={"Telefone"}
                        valor={telefone}
                        func={(e) => setTelefone(mascaraTelefone(e))}
                        tipo="tel"
                        inputMode="tel"
                    />

                    <div className="input-criacao-usuario margin-vertical-30">
                        <label className="titulo-input-criacao">
                            Descrição:
                        </label>
                        <textarea
                            className="form-control input-dados-criar"
                            maxLength="100"
                            id="exampleFormControlTextarea1"
                            onChange={(c) => setDescricao(c.target.value)}
                            rows="3"
                            value={descricao || " "}
                        />
                    </div>

                    {nivelSelecionado === "subadmin" && (
                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">Permissões:</label>
                            <small style={{ color: '#888' }}>
                                As permissões poderão ser configuradas após a criação do usuário.
                            </small>
                        </div>
                    )}

                    {nivelSelecionado === "gerente" && (
                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">
                                Permissões:
                            </label>
                            <div className="funkyradio-info">
                                <input
                                    type="checkbox"
                                    id="criar-operador"
                                    onChange={() =>
                                        setPermissaoCriarOperador(
                                            !permissaoCriarOperador
                                        )
                                    }
                                    checked={permissaoCriarOperador}
                                />
                                &nbsp;
                                <label htmlFor="criar-operador">
                                    Criar Cambista
                                </label>
                                <br />
                                <input
                                    type="checkbox"
                                    id="adicionar-saldo"
                                    onChange={() =>
                                        setPermissaoAdicionarSaldo(
                                            !permissaoAdicionarSaldo
                                        )
                                    }
                                    checked={permissaoAdicionarSaldo}
                                />
                                &nbsp;
                                <label htmlFor="adicionar-saldo">
                                    Adicionar saldo
                                </label>
                            </div>
                        </div>
                    )}

                    {nivelSelecionado === "operador" && (
                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">
                                Permissões:
                            </label>
                            <div className="funkyradio-info">
                                <input
                                    type="checkbox"
                                    id="exibir-logo"
                                    onChange={() =>
                                        setPermissaoExibirLogo(
                                            !permissaoExibirLogo
                                        )
                                    }
                                    checked={permissaoExibirLogo}
                                />
                                &nbsp;
                                <label htmlFor="exibir-logo">
                                    Exibir logo
                                </label>
                                <br />
                                <input
                                    type="checkbox"
                                    id="milhar-brinde"
                                    onChange={() =>
                                        setMilharBrindeUsuario(!milharBrindeUsuario)
                                    }
                                    checked={milharBrindeUsuario}
                                />
                                &nbsp;
                                <label htmlFor="milhar-brinde">
                                    Milhar brinde
                                </label>
                            </div>
                        </div>
                    )}
                </div>

                {nivelSelecionado === "operador" && (
                    <div style={{ padding: 10 }}>
                        <p style={{ color: "#cc0000" }}>
                            <strong>Milhar:</strong> para milhar e suas subcategorias.
                        </p>
                        <p style={{ color: "#cc0000" }}>
                            <strong>Centena:</strong> para centena e suas subcategorias.
                        </p>
                        <p style={{ color: "#cc0000" }}>
                            <strong>Dezena:</strong> para dezena e suas subcategorias.
                        </p>
                        <p style={{ color: "#cc0000" }}>
                            <strong>Grupo:</strong> para grupo e suas subcategorias.
                        </p>
                    </div>
                )}

                <div
                    style={{
                        padding: "0 10px",
                        justifyContent: "left",
                    }}
                    className="d-flex m-b m-t"
                >
                    <button
                        style={{
                            display: "block",
                            width: "270px",
                            marginLeft: "150px",
                        }}
                        className="btn btn-success"
                        onClick={(e) => enviarUsuario(e)}
                        disabled={carregaPost}
                    >
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    );
}